/**
 * Abstract class for typing
 */
export class EventDispatcherEvent {
    static values () {
        return Object.values(this);
    }
}

export class EventDispatcher {
    /**
     * @type {string}
     */
    static EventPrefix;

    /**
     *
     */
    static EventTypes = [];

    /**
     * @param {string} eventType
     * @param {*} data
     */
    dispatch (eventType, data) {
        const { EventPrefix } = this.constructor;

        if (!EventPrefix) {
            throw new Error('EventPrefix must be defined in subclass');
        }

        if (!this.constructor.EventTypes.includes(eventType)) {
            throw new Error(`Invalid event type: ${eventType}`);
        }

        window.dispatchEvent(
            new CustomEvent(`${EventPrefix}-${eventType}`, { detail: data })
        );
    }
}
